import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../../pages/home/home";
import View360 from "../../pages/360-view/view360";
import Contact from "../../pages/contact-us/contact";
import Galery from "../../pages/gallery/galery";
import About from "../../pages/about-us/about";
import Menu from "../../pages/menu/menu";
import SpecialDetail from "../../pages/special-detail/specialDetail";
import SubTypes from "../../component/food-types/subTypes";
import Catalog from "../../pages/catalog/catalog";
import Barmenu from "../../pages/barAndfood/barmenu";
import PartyPackages from "../../pages/party packages/partyPackages";
import FoodMenu from "../../pages/barAndfood/foodMenu";
import ReserveTable from "../../pages/reservation/reserve";

const RoutePage = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />}></Route>
      <Route path="/360-degree" element={<View360 />}></Route>
      <Route path="/contact-us" element={<Contact />}></Route>
      <Route path="/gallery/" element={<Galery />}></Route>
      <Route path="/about-us" element={<About />}></Route>
      <Route path="/catalog" element={<Catalog />}></Route>
      <Route path="/menu/:types" element={<SubTypes />}></Route>
      <Route path="/g/:types" element={<SpecialDetail />}></Route>
      <Route path="/catalog/:title" element={<Menu />}></Route>
      <Route path="/barmenu" element={<Barmenu />}></Route>
      <Route path='/foodmenu' element={<FoodMenu />}></Route>
      <Route path="/partypackages" element={<PartyPackages />}></Route>
      <Route path='/make-reservation' element={<ReserveTable />}></Route>
    </Routes>
  );
};

export default RoutePage;
